<template>
  <div>
    <div class="container">
      <hero-carousel :banners="banners" />
    </div>

    <section class="section-block">
      <div class="container">
        <section-title
          kicker="Công ty TNHH NWM Việt Nam"
          title="Đối tác kỹ thuật cho hệ thống nước và môi trường"
          description="Đồng hành cùng doanh nghiệp từ bảo trì, vận hành đến thi công, nâng cấp và cung ứng vật tư ngành nước."
        />
        <div class="section-card company-intro-card p-4 p-lg-5">
          <div class="row align-items-center">
            <div class="col-lg-7 mb-4 mb-lg-0">
              <h3 class="font-weight-bold text-primary mb-3">{{ companyInfo.companyName }}</h3>
              <p class="section-copy mb-0">
                {{ companyInfo.description || "Công ty TNHH NWM Việt Nam chú trọng giải pháp kỹ thuật phù hợp, vận hành ổn định và độ bền dài hạn cho hệ thống." }}
              </p>
            </div>
            <div class="col-lg-5">
              <div class="service-focus-item">
                <span class="service-focus-number">01</span>
                <span>Bảo trì &amp; vận hành</span>
              </div>
              <div class="service-focus-item">
                <span class="service-focus-number">02</span>
                <span>Thi công &amp; nâng cấp</span>
              </div>
              <div class="service-focus-item mb-0">
                <span class="service-focus-number">03</span>
                <span>Thương mại vật tư ngành nước</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-block pt-0">
      <div class="container">
        <section-title
          kicker="Dịch vụ"
          title="Giải pháp toàn diện cho ngành nước"
          description="Từ vận hành hệ thống đến cung ứng thiết bị, vật tư chuyên ngành."
        />
        <div class="row">
          <div
            v-for="(service, index) in services"
            :key="service._id || service.title"
            class="col-lg-4 col-md-6 mb-4"
          >
            <service-card
              :icon="service.icon"
              :title="service.title"
              :description="service.description"
              :category="service.category"
              :number="service.displayOrder || index + 1"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="section-block pt-0">
      <div class="container">
        <section-title
          kicker="Tin nổi bật"
          title="Kiến thức vận hành, bảo trì và nâng cấp hệ thống nước"
          description="Cập nhật các bài viết hữu ích để doanh nghiệp chủ động hơn trong việc bảo trì và tối ưu hiệu suất."
        />
        <div class="row">
          <div v-for="post in featuredPosts" :key="post._id" class="col-lg-6 col-xl-4 mb-4">
            <post-card :post="post" />
          </div>
        </div>
      </div>
    </section>

    <section class="section-block pt-0">
      <div class="container">
        <div class="section-card water-gradient text-white p-4 p-lg-5">
          <div class="row align-items-center">
            <div class="col-lg-8 mb-4 mb-lg-0">
              <div class="section-kicker bg-white text-primary">Liên hệ</div>
              <h2 class="section-heading text-white">Bạn cần khảo sát hệ thống nước hoặc gói bảo trì định kỳ?</h2>
              <p class="mb-0" style="font-size: 18px; line-height: 1.8; opacity: 0.92;">
                Gửi nhu cầu để đội ngũ của chúng tôi tư vấn lộ trình triển khai phù hợp cho doanh nghiệp.
              </p>
            </div>
            <div class="col-lg-4 text-lg-right">
              <router-link :to="{ name: 'contact' }" class="brand-btn brand-btn-secondary bg-white">
                Yêu cầu tư vấn
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  fetchBanners,
  fetchCompanyInfo,
  fetchPosts,
  fetchServices
} from "../../api/public";
import HeroCarousel from "../../components/HeroCarousel.vue";
import SectionTitle from "../../components/SectionTitle.vue";
import ServiceCard from "../../components/ServiceCard.vue";
import PostCard from "../../components/PostCard.vue";

export default {
  name: "HomeView",
  components: {
    HeroCarousel,
    SectionTitle,
    ServiceCard,
    PostCard
  },
  data: function data() {
    return {
      banners: [],
      companyInfo: {},
      posts: [],
      services: []
    };
  },
  computed: {
    featuredPosts: function featuredPosts() {
      return this.posts.slice(0, 3);
    }
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const [bannerResponse, companyResponse, postResponse, serviceResponse] = await Promise.all([
        fetchBanners(),
        fetchCompanyInfo(),
        fetchPosts({ page: 1, limit: 6 }),
        fetchServices()
      ]);

      this.banners = bannerResponse.data;
      this.companyInfo = companyResponse.data;
      this.posts = postResponse.data.items;
      this.services = serviceResponse.data;
    }
  }
};
</script>

<style scoped>
.company-intro-card {
  overflow: hidden;
  background:
    radial-gradient(circle at 100% 0, rgba(0, 191, 255, 0.09), transparent 34%),
    #fff;
}

.service-focus-item {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 14px;
  padding: 13px 16px;
  border: 1px solid rgba(0, 61, 153, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.8);
  color: var(--deep-navy);
  font-weight: 700;
}

.service-focus-number {
  color: var(--sky-blue);
  font-size: 13px;
  font-weight: 800;
}
</style>
